import { render, staticRenderFns } from "./curtailTable.vue?vue&type=template&id=5852259e&scoped=true&"
import script from "./curtailTable.vue?vue&type=script&lang=js&"
export * from "./curtailTable.vue?vue&type=script&lang=js&"
import style0 from "./curtailTable.vue?vue&type=style&index=0&id=5852259e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852259e",
  null
  
)

export default component.exports